const slice = "book";

export const BOOK_LOADED = `${slice}/loaded`;
export const BOOK_ADDED = `${slice}/added`;
export const BOOK_REMOVED = `${slice}/removed`;
export const BOOK_EDITED = `${slice}/edited`;